module.exports = __webpack_public_path__ + "img/vk-icon.3cc29103.svg";